/**
 * The country the editor's times are translated to (15/10/2026 — the
 * Danish clock): its timezone, flag and run date, set once by the country
 * page (and the editor) so every time reads Danish first with "🇦🇺 18:00"
 * beside it, without passing props down.
 * For Media Devoted | Created By Ciro Autiero
 */
import { createContext, FC, ReactNode, useContext } from 'react';

export interface CountryClock {
  /** The country's IANA timezone; null = not set in the catalog. */
  tz: string | null;
  /** The country's flag emoji. */
  flag: string;
  /** The day the times are read for (the preview's run date); absent = today in the country. */
  runDate?: string | null;
}

const CountryClockContext = createContext<CountryClock>({ tz: null, flag: '🌍' });

export const CountryClockProvider: FC<{ value: CountryClock; children: ReactNode }> = ({ value, children }) => (
  <CountryClockContext.Provider value={value}>{children}</CountryClockContext.Provider>
);

export const useCountryClock = (): CountryClock => useContext(CountryClockContext);
